import { ISsetor, Setor } from "../setor/Setor";
import { IStipoDocumento, TipoDocumento } from "../tipoDocumento/TipoDocumento";
import { IStipoProcesso, TipoProcesso } from "../tipoProcesso/TipoProcesso";
import { Usuario } from "../usuario/Usuario";
import { ISusuarioList, UsuarioList } from "../usuario/UsuarioList";
import { ISprocesso, Processo } from "./Processo";

export interface ProcessoEnviarDTO {
    id: string;
    processoId: string;
    setoresIds: string[];
    manterUnidadeAtual: boolean;
}
export const ISprocessoEnviarDTO: ProcessoEnviarDTO = {
    id: "",
    processoId: "",
    setoresIds: [],
    manterUnidadeAtual: true,
}

export interface ProcessoSobrestarDTO {
    id: string;
    processoId: string;
    observacaoSobrestado: string

}
export const ISprocessoSobrestarDTO: ProcessoSobrestarDTO = {
    id: "",
    processoId: "",
    observacaoSobrestado: "",
}

export interface ProcessoConcluirDTO {
    id: string;
    processoId: string;
    observacaoConcluido: string

}
export const ISprocessoConcluirDTO: ProcessoConcluirDTO = {
    id: "",
    processoId: "",
    observacaoConcluido: "",
}

export interface ProcessoPrazoDTO {
    id: string;
    processoId: string;
    data: string;
    prazo_dias: string;
    prazo_dias_uteis: string;

}
export const ISprocessoPrazoDTO: ProcessoPrazoDTO = {
    id: "",
    processoId: "",
    data: "",
    prazo_dias: "",
    prazo_dias_uteis: "",
}






export interface ProcessoSetores {
    id: string;
    processoId: string;
    setor: Setor;
    data: string;
    usuario: UsuarioList;
    concluido: boolean;
    sobrestado: boolean;


}

export const ISprocessoSetores: ProcessoSetores = {
    id: "",
    processoId: "",
    setor: ISsetor,
    data: "",
    usuario: ISusuarioList,
    concluido: false,
    sobrestado: false,

}

export interface ProcessoSetoresList {
    id: string;
    setor: Setor;
    usuario: UsuarioList;
    data: string;
    processoId: string;
    concluido: boolean;
    sobrestado: boolean;
    usuarioRecibo: UsuarioList;
    dataRecibo: string;
    usuarioSobrestado: UsuarioList;
    dataSobrestado: string;
    observacaoSobrestado: string;
    usuarioConcluido: UsuarioList;
    dataConcluido: string;
    observacaoConcluido: string;
    dataTermino: string;
    usuarioTermino: UsuarioList;

}

export const ISprocessoSetoresList: ProcessoSetoresList = {
    id: "",
    setor: ISsetor,
    usuario: ISusuarioList,
    data: "",
    processoId: "",
    concluido: false,
    sobrestado: false,
    usuarioRecibo: ISusuarioList,
    dataRecibo: "",
    usuarioSobrestado: ISusuarioList,
    dataSobrestado: "",
    observacaoSobrestado: "",
    usuarioConcluido: ISusuarioList,
    dataConcluido: "",
    observacaoConcluido: "",
    dataTermino: "",
    usuarioTermino: ISusuarioList,
}